import { observer } from "mobx-react-lite"
import { RowStyled, VolumeLevelStyled } from "./Row.styled"
import { FC, useMemo } from "react"

type TPercent = number

interface IRow {
    price?: number
    volume: string
    color: string
    width: TPercent
}

const Row: FC<IRow> = observer(({price, volume, color, width}) => {
  const transformedPrice = useMemo(() => {
    return price ? makeNumber(price) : undefined
  }, [price])

  const [first, second] = useMemo(() => {
    if (transformedPrice) {
      return [transformedPrice, volume]
    }
    
    return [volume, transformedPrice]
  }, [transformedPrice, volume])

  return (
    <RowStyled>
      <p style={{ color}}>{first}</p>
      <p style={{ color}}>{second}</p>
      {/* {!transformedPrice && <p style={{color}}>0</p>} */}
      <VolumeLevelStyled
        style={{
          backgroundColor: color,
          width: `${width}%`,
        }}
      />
    </RowStyled>
  )
})

export function makeNumber(number: number) {
  const digits = 6

  while (!(number < 10**digits && number >= 10**(digits-1))) {
    if (number < 10**(digits-1)) {
      number = number * 10
    }
    if (number >= 10**digits) {
      number = number / 10
    }
  }

  return Math.round(number)
}

export default Row